import { changeEnv, ENV } from "@goono-frontend-api/services/api";
import React from "react";
import config from "../../functions/config";

export const useInitializeEnv = () => {
  React.useEffect(() => {
    const test_mode = process.env.REACT_APP_TEST_ENABLED?.toLocaleLowerCase();
    const app_api_server = process.env.REACT_APP_API_SERVER;
    const app_ipfs_api_server = process.env.REACT_APP_IPFS_API_SERVER;

    if (test_mode === "1" || test_mode === "y") {
      if (config.isTestServer) changeEnv("test");
      else changeEnv("staging");

      if (app_api_server && app_api_server.trim() !== "")
        ENV.API_SERVER = app_api_server!;

      if (app_ipfs_api_server && app_ipfs_api_server.trim() !== "")
        ENV.IPFS_API_SERVER = app_ipfs_api_server!;

      console.log("환경 변경: ", ENV);
    }
  }, []);
};
